import { gql } from "@apollo/client"

export const ConfirmSmsVerification = gql`
  mutation ConfirmSmsVerification($input: ConfirmSmsVerificationInput!) {
    confirmSmsVerification(input: $input) {
      success
      errors
    }
  }
`

export const Logout = gql`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      errors
    }
  }
`
